import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { client } from "shared/helpers/client";
import { passwordPattern } from "shared/helpers/utils";
import * as yup from "yup";

interface InvitationData {
    name:string;
    password:string;
    confirmNewPassword:string;
    jobDescription:string,
    email:string
}

interface TokenData {
    code:string
    name:string;
    JobDescription:string,
    Email:string
}

export function useConfirmInviteUser(dataInv:TokenData) {
    const {t} = useTranslation();

    const confirmInvitationForm = useForm<InvitationData>({
        resolver:yupResolver(yup.object().shape({
            name:yup.string().required(t('errors.required')),
            password: yup.string().required(t("errors.required")).matches(passwordPattern,t('errors.invalid-password')),
            confirmNewPassword: yup.string().required(t("errors.required")).equals([yup.ref('password')], t('errors.password-mismatch')),
            jobDescription:yup.string(),
            email:yup.string()
        })),
    })

    const restInvForm = ()=>{
        confirmInvitationForm.reset({
            email:dataInv?.Email ?? '',
          jobDescription:dataInv?.JobDescription ?? ''
        });
      }
    
      useEffect(()=>{
        if(dataInv){
          restInvForm()
        }
      },[])

    const confirmInvitationServer = useMutation(invitation => client('/ManageEmployee/AcceptInvitaion',{data:invitation}))

    return {confirmInvitationForm,confirmInvitationServer}
}